/* GENERATED by scripts/gen-icons.mjs — DO NOT EDIT BY HAND.
 * Regenerate: npm run gen:icons   ·   Verify: npm run gen:icons:check
 *
 * The design names icons in kebab-case; lucide-react exports PascalCase. Named imports keep this
 * tree-shakeable — importing lucide-react wholesale would pull ~1,500 icons into the bundle for
 * the 100 the console actually uses.
 *
 * Two names have no lucide glyph. The design system already substitutes its functional set from
 * Lucide (see its readme), so these follow the same rule — recorded, not invented:
 *   plus-minus → Diff
 *   shield-user → UserCog
 */
import {
  Activity,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Banknote,
  Bell,
  BellOff,
  BookOpen,
  Building,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX,
  ChartNoAxesColumn,
  Check,
  ChevronDown,
  ChevronRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleUser,
  Clock,
  Construction,
  CornerDownRight,
  CreditCard,
  Diff,
  Download,
  Eye,
  FileCheck,
  FileText,
  Filter,
  Flame,
  Gavel,
  GitBranch,
  GitCompare,
  GitMerge,
  Globe,
  Grid3x3,
  HelpCircle,
  IdCard,
  Image,
  IndianRupee,
  Info,
  KeyRound,
  Keyboard,
  Landmark,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Link,
  ListChecks,
  ListOrdered,
  Lock,
  LogOut,
  MapPin,
  Medal,
  Megaphone,
  Monitor,
  Moon,
  Package,
  Palette,
  PanelLeftClose,
  PanelLeftOpen,
  Pause,
  Pencil,
  Percent,
  Phone,
  Play,
  Plus,
  ReceiptIndianRupee,
  RefreshCw,
  Repeat,
  Rocket,
  RotateCcw,
  Scale,
  ScrollText,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Star,
  Sun,
  Tag,
  Timer,
  ToggleLeft,
  Trash2,
  TriangleAlert,
  Undo2,
  Upload,
  UserCheck,
  UserCog,
  UserPlus,
  UserRound,
  UserX,
  Users,
  Webhook,
  X,
  type LucideIcon,
} from 'lucide-react';

export const ICONS = {
  'activity': Activity,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'banknote': Banknote,
  'bell': Bell,
  'bell-off': BellOff,
  'book-open': BookOpen,
  'building': Building,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-plus': CalendarPlus,
  'calendar-x': CalendarX,
  'chart-no-axes-column': ChartNoAxesColumn,
  'check': Check,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'circle': Circle,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-user': CircleUser,
  'clock': Clock,
  'construction': Construction,
  'corner-down-right': CornerDownRight,
  'credit-card': CreditCard,
  'download': Download,
  'eye': Eye,
  'file-check': FileCheck,
  'file-text': FileText,
  'filter': Filter,
  'flame': Flame,
  'gavel': Gavel,
  'git-branch': GitBranch,
  'git-compare': GitCompare,
  'git-merge': GitMerge,
  'globe': Globe,
  'grid-3x3': Grid3x3,
  'help-circle': HelpCircle,
  'id-card': IdCard,
  'image': Image,
  'indian-rupee': IndianRupee,
  'info': Info,
  'key-round': KeyRound,
  'keyboard': Keyboard,
  'landmark': Landmark,
  'layers': Layers,
  'layout-dashboard': LayoutDashboard,
  'life-buoy': LifeBuoy,
  'link': Link,
  'list-checks': ListChecks,
  'list-ordered': ListOrdered,
  'lock': Lock,
  'log-out': LogOut,
  'map-pin': MapPin,
  'medal': Medal,
  'megaphone': Megaphone,
  'monitor': Monitor,
  'moon': Moon,
  'package': Package,
  'palette': Palette,
  'panel-left-close': PanelLeftClose,
  'panel-left-open': PanelLeftOpen,
  'pause': Pause,
  'pencil': Pencil,
  'percent': Percent,
  'phone': Phone,
  'play': Play,
  'plus': Plus,
  'plus-minus': Diff,
  'receipt-indian-rupee': ReceiptIndianRupee,
  'refresh-cw': RefreshCw,
  'repeat': Repeat,
  'rocket': Rocket,
  'rotate-ccw': RotateCcw,
  'scale': Scale,
  'scroll-text': ScrollText,
  'search': Search,
  'settings': Settings,
  'shield': Shield,
  'shield-check': ShieldCheck,
  'shield-user': UserCog,
  'signpost': Signpost,
  'sliders-horizontal': SlidersHorizontal,
  'smartphone': Smartphone,
  'star': Star,
  'sun': Sun,
  'tag': Tag,
  'timer': Timer,
  'toggle-left': ToggleLeft,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  'undo-2': Undo2,
  'upload': Upload,
  'user-check': UserCheck,
  'user-plus': UserPlus,
  'user-round': UserRound,
  'user-x': UserX,
  'users': Users,
  'webhook': Webhook,
  'x': X,
} satisfies Record<string, LucideIcon>;

/** Every icon name the design references. A name outside this set is a typo, not a new icon. */
export type IconName = keyof typeof ICONS;
